import * as React from 'react';
import { getMetaClientReferenceId, trackInitiateCheckout } from '../lib/metaPixel';

export const DEFAULT_STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/eVadRXei0fgT5fW288';

export function resolveStripePaymentLink() {
  const configured = process.env.REACT_APP_STRIPE_PAYMENT_LINK;
  if (typeof configured === 'string' && configured.trim()) {
    return configured.trim();
  }
  return DEFAULT_STRIPE_PAYMENT_LINK;
}

function CaseBuyButton() {
  const firedRef = React.useRef(false);
  const [clientReferenceId, setClientReferenceId] = React.useState('');
  const paymentLink = resolveStripePaymentLink();

  const fireInitiateCheckout = React.useCallback(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    // Purchase is not fired here — Stripe checkout completes off-site.
    trackInitiateCheckout();
  }, []);

  React.useEffect(() => {
    setClientReferenceId(getMetaClientReferenceId());
  }, []);

  return (
    <div
      className="flex flex-wrap items-center gap-4"
      onClick={fireInitiateCheckout}
      onPointerDown={fireInitiateCheckout}
    >
      <stripe-buy-button
        buy-button-id="buy_btn_1Oe4WlLR4ke7jgCCRZ8NO5N6"
        publishable-key="pk_live_51OLyiuLR4ke7jgCCMdE4JxkNO8ywtnPQ4FZlEzFLbBkZYjFE5vE9wbO2hJwOs1ZCYoh4HJ2MD6F3yqxopjg9Ev4300w8E0oo6f"
        client-reference-id={clientReferenceId || undefined}
      >
      </stripe-buy-button>
      <a href={paymentLink} className="text-primary font-semibold underline">
        Buy now – $15.99
      </a>
    </div>
  );
}

export default CaseBuyButton;
